module.exports = __webpack_public_path__ + "1104e40b1e1a18c1f280e1bf0ea1a19f.png";